import { styled } from '@/styled-system/jsx';
import ConnectedModuleCard from '../ConnectedModuleCard';

export const StyledConnectedModuleCard = styled(ConnectedModuleCard, {
  base: {
    minHeight: '510px',
    display: 'flex',
    flexDirection: 'column',
  },
});
